<app-landing-toolbar></app-landing-toolbar>
<div class="landing-top-card primary-background">
    <div class="landing-content">
        <h1 class="site-title">DeckPlan</h1>
        <h3>Build your best Magic: The Gathering deck plan.</h3>
        Sign up for free! You'll get access to our powerful deck building tools.
        <form [formGroup]="signUp" (submit)="onSubmit()">
            <mat-form-field appearance="outline">
                <input formControlName="alias" matInput placeholder="Username" required>
            </mat-form-field>
            <mat-form-field class="left-pad" appearance="outline">
                <input formControlName="email" type="email" matInput placeholder="Email" required>
            </mat-form-field>
            <button class="signup-button" mat-raised-button color="accent" type="submit" gtagEvent trackOn="click" action="sign_up" category="account">Start planning now!</button>
        </form>
        Already a member? <a class="accent" routerLink="/home" gtagEvent trackOn="click" action="login" category="account">Log in!</a>
    </div>
</div>
<div class="landing-content column-flex">
    <div class="row-flex">
        <div class="lower-page-child">
            <h2>Track your collection</h2>
            Track your collection, plan decks, and show off your plans! Deckplan provides tools
            to help you on your journey to top your competition. You'll find everything from
            color counts, converted mana cost (CMC) spread, and mana source/sink balances displayed in
            handy visual representation, all the way to deck-building tools that analyze
            the current game meta and help you build powerful decks from the cards you already have or
            could pick up to complement your collection.
        </div>
        <div class="card-grid lower-page-child primary-background">
            <div class="deck">
                <img class="deck-front magic-card large-magic-card" [src]="deckFrontCard?.images.normal"
                     [alt]="deckFrontCard?.name">
                <div class="large-magic-card faux-card magic-card" style="top: 10px; left: 10px;"></div>
                <div class="large-magic-card faux-card magic-card" style="top: 20px; left: 20px;"></div>
                <div class="large-magic-card faux-card magic-card" style="top: 30px; left: 30px;"></div>
                <div class="large-magic-card faux-card magic-card" style="top: 40px; left: 40px;"></div>
            </div>
            <img *ngFor="let card of deckSmallCards" class="magic-card" [src]="card.images.small" [alt]="card.name">
        </div>
    </div>
    <div class="row-flex">
        <div>
            <h2>Our Most Popular Decks</h2>
            <app-pretty-deck-list [decks]="publicDecks | async" [isPublicView]="true"></app-pretty-deck-list>
        </div>
    </div>
</div>
